import { trigger, transition, group, style, query, animate } from "@angular/animations";

export let pageChange = trigger("PageChange", [
    transition("* <=> *", [
        group([
            query("app-index", [], {optional: true}),
            query(":enter", [
                style({position: "absolute", top: "-10vh", bottom: "10vh", right: 0, left: 0, opacity: 0}),
                animate(".2s ease-in-out", style({top: 0, bottom: 0, opacity: 1}))
            ], {optional: true}),
            query(":leave", [
                style({position: "absolute", top: 0, right: 0, left: 0, bottom: 0, opacity: 1}),
                animate(".2s ease-in-out", style({top: "-10vh", bottom: "10vh", opacity: 0}))
            ], {optional: true}),
        ])
    ])
]);